import { IFilter } from "@/api/AppApi/services/filters/interfaces/IGetFilters";
import { getOptionAvailability } from "../../common-filters-components/option-availability";
import OptionsCarousel from "../../common-filters-components/OptionsCarousel";
import SvgColorOption from "../../common-filters-components/SvgColorOption";
import {
  isSelected,
  toggleOption,
} from "../../common-filters-components/toggleOption";

interface Props {
  filter: IFilter;
  state: string[];
  setState: (state: string[]) => void;
  unAvailabeKeys?: string[];
  isFilterDrawer?: boolean;
  sliderMaxWidth?: number;
  outOfStockKeys?: string[];
  disabledKeys?: string[];
  isProductBox?: boolean;
  allow_user_request_stock_availability_reminder?: boolean;
}

const ColorFilter: React.FC<Props> = ({
  filter,
  state,
  setState,
  isFilterDrawer = false,
  unAvailabeKeys = [],
  sliderMaxWidth,
  outOfStockKeys,
  disabledKeys,
  isProductBox,
  allow_user_request_stock_availability_reminder,
}) => {
  const options = filter.data;
  const multiSelect = filter.configurations.is_multi_select;
  const handleOption = (key: string) => {
    const currentSelected = toggleOption(state, key, multiSelect);
    setState(currentSelected);
  };
  if (!options) return null;
  return (
    <div>
      <OptionsCarousel
        spacing={isProductBox ? 6 : 8}
        width={isProductBox ? 16 : 32}
        isFilterDrawer={isFilterDrawer}
        sliderMaxWidth={sliderMaxWidth}
      >
        {options
          ?.filter((op) => !isSelected(unAvailabeKeys, op.key))
          ?.map((option) => {
            const { disabled, outOfStock } = getOptionAvailability({
              optionKey: option.key,
              unAvailabeKeys,
              outOfStockKeys,
              disabledKeys,
              allowRequestStockReminder:
                allow_user_request_stock_availability_reminder,
            });
            return (
              <SvgColorOption
                key={option.key}
                disabled={disabled}
                selected={isSelected(state, option.key)}
                toggleOption={() => handleOption(option.key)}
                color={option.value}
                isProductBox={isProductBox}
                outOfStock={outOfStock}
              />
            );
          })}
      </OptionsCarousel>
    </div>
  );
};

export default ColorFilter;
